import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Table, Button, Drawer,
} from 'antd';
import OfferActions from '@Actions/offerActions';
import SellerActions from '@Actions/sellerActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Helpers from '@Apis/helpers';
import OfferForm from '@Components/Common/Form/OfferForm';
import './style.scss';

/**
 * SelectOfferBulk component
 *
 * @param file
 */
class SelectOfferBulk extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    const innerTableColumns = [
      {
        title: 'Location',
        width: '150px',
        render: (text, record) => `${record?.tenant_name || ''}`,
      },
      {
        title: 'MOQ',
        width: '80px',
        render: (text, record) => `${record?.moq || ''}`,
      },
      {
        title: 'Unit Price',
        width: '100px',
        render: (text, record) => `${this.props.MONEY(record?.offer_price || 0)}`,
      },
    ];
    this.state = {
      page: 1,
      limit: 10,
      tableColumns: [
        {
          title: 'Vendor Name',
          dataIndex: 'seller_name',
          render: (text, record) => {
            let sellerName = record?.seller_info?.seller_name;
            if (record?.office_address_details?.city) sellerName += ` (${record?.office_address_details?.city})`;
            return <div style={{ color: '#2D7DF7', fontWeight: '600' }}>{sellerName}</div>;
          },
        },
        {
          title: 'LOCATION',
          width: '150px',
          onCell: (item, index) => ({ colSpan: 3 }),
          render: (record) => (
            <div>
              <Table
                showHeader={false}
                size="small"
                scroll="scroll"
                columns={innerTableColumns}
                dataSource={record?.offers}
                pagination={false}
                bordered
              />
            </div>
          ),
        },
        {
          title: 'MOQ',
          width: '80px',
          render: (record) => (<div />),
          onCell: (item, index) => ({ colSpan: 0 }),
        },
        {
          title: 'UNIT PRICE',
          width: '100px',
          render: (record) => (<div />),
          onCell: (item, index) => ({ colSpan: 0 }),
        },
        {
          title: '',
          dataIndex: '',
          width: '88px',
          render: (text, record) => {
            const { handleSellerSelection, toggleOfferModal, currentLine } = this.props;
            return (
              <div style={{ display: 'flex' }}>
                <Button
                  type="primary"
                  shape="round"
                  size="small"
                  onClick={() => {
                    handleSellerSelection(record, currentLine);
                    toggleOfferModal();
                  }}
                >
                  Select
                </Button>
              </div>
            );
          },
        },
      ],
      isEditing: false,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { getSellers, user, selectedTenantsForCurrentVendor } = this.props;
    if (selectedTenantsForCurrentVendor) {
      getSellers('', selectedTenantsForCurrentVendor, 1, 10);
    } else {
      getSellers('', user?.tenant_info?.tenant_id, 1, 10);
    }
  }

  /**
   *
   * @param sellers
   * @return {*[]}
   */
  getSellers = (sellers) => {
    const updateSellers = [];
    if (sellers) {
      for (let i = 0; i < sellers.length; i++) {
        updateSellers.push({
          ...sellers[i],
          key: i,
        });
      }
    }
    return updateSellers;
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      tableColumns, isEditing, addOfferModal, selectedOffer, page, limit,
    } = this.state;
    const {
      selectOfferVisible, toggleOfferModal, getAllSellerOffersLoading, currentLine,
      getAllSellerOffers, user, productSkuId, tenantIds, allSellerOffers, selectedTenantsForCurrentVendor,
    } = this.props;
    return (
      <Drawer
        open={selectOfferVisible}
        onClose={() => toggleOfferModal()}
        destroyOnClose
        width="720px"
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '675px' }}>
            <H3Text text="Select Vendor Price" className="custom-drawer__title" style={{ width: '640px' }} />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => toggleOfferModal()} />
          </div>
        </div>
        <H3Text text={currentLine?.productName} className="select-bulk-offer__product-name" />
        <div className="generic-table-container select-offer-table">
          <Table
            bordered
            loading={getAllSellerOffersLoading}
            showHeader
            size="small"
            scroll="scroll"
            tableLayout="unset"
            top="none"
            bottom="bottomRight"
            columns={tableColumns}
            dataSource={allSellerOffers ? allSellerOffers?.offers?.sellers : []}
            title={() => (
              <div className="select-offer__table-header">
                {`${allSellerOffers?.offers?.sellers?.length || '0'} Vendor Price(s) Available`}
                {Helpers.getPermission(Helpers.permissionEntities.VENDOR_PRICE, Helpers.permissionTypes.CREATE, user) && (
                  <div className="select-offer__table-header__left">
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Vendor Price"
                      onClick={() => this.setState({ addOfferModal: true })}
                      customClass="select-offer__add-button"
                    />
                  </div>
                )}
              </div>
            )}
            rowClassName={(record) => (!record.is_active ? 'inactive_record' : '')}
          />
        </div>
        <Drawer
          open={addOfferModal}
          destroyOnClose
          footer={null}
          width="360px"
          onClose={
            () => this.setState({
              addOfferModal: false,
              isEditing: false,
            })
          }
        >
          <OfferForm
            currentLine={currentLine}
            selectedOffer={selectedOffer}
            callback={() => {
              this.setState({
                addOfferModal: false,
                isEditing: false,
              });
              getAllSellerOffers(productSkuId, tenantIds, page, limit);
            }}
            isEditing={isEditing}
            toggleNewOfferModal={() => this.setState({ addOfferModal: false })}
            selectedTenantsForCurrentVendor={selectedTenantsForCurrentVendor}
          />
        </Drawer>

      </Drawer>
    );
  }
}

const mapStateToProps = ({ OfferReducers, SellerReducers, UserReducers }) => ({
  getAllSellerOffersLoading: OfferReducers.getAllSellerOffersLoading,
  allSellerOffers: OfferReducers.allSellerOffers,
  sellers: SellerReducers.sellers,
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
  getAllSellerOffers: (productSkuId, tenantIds, page, limit) => dispatch(OfferActions.getAllSellerOffers(productSkuId, tenantIds, page, limit)),
  getSellers: (keyword, tenantId, page, limit) => dispatch(SellerActions.getSellers(keyword, tenantId, page, limit)),
});

SelectOfferBulk.propTypes = {
  getAllSellerOffers: PropTypes.func,
  getAllSellerOffersLoading: PropTypes.bool,
  offers: PropTypes.any,
  selectOfferVisible: PropTypes.bool,
  toggleOfferModal: PropTypes.func,
  getSellers: PropTypes.func,
  user: PropTypes.any,
  currentLine: PropTypes.any,
  handleSellerSelection: PropTypes.any,
  productSkuId: PropTypes.any,
  tenantIds: PropTypes.any,
  allSellerOffers: PropTypes.any,
  selectedTenantsForCurrentVendor: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectOfferBulk));
